module.exports = __webpack_public_path__ + "img/backVideo.8746f490.svg";